// extracted by mini-css-extract-plugin
export var card = "card-alt-module--card--3zokQ";
export var title = "card-alt-module--title--2eNJS";
export var link = "card-alt-module--link--2UsxW";
export var content = "card-alt-module--content--XS1-H";
export var labelItems = "card-alt-module--labelItems--20I3y";
export var fieldTitle = "card-alt-module--fieldTitle--1ns1L";